module.exports = __webpack_public_path__ + "img/logo_uninter.2d4a5dab.jpg";